module.exports = __webpack_public_path__ + "img/txt_info1.5036534d.png";